'use client'
import { Button } from "@/components/ui/button";
import { useDeleteHeroService } from "@/lib/hooks/admin-dashboard/hero-services/delete/useDeleteHeroService";
import { Trash } from "lucide-react";
import Image from "next/image";
import Link from "next/link";

const ServiceCard = ({ service, isEditor }: { service: HeroServices, isEditor?: boolean }) => {
  const { mutate: deleteHeroService } = useDeleteHeroService();
  return (
    <div className="flex flex-col gap-2">
      <Link href={`https://skillsewa.info/booking?title=${service.title}`}>
        <aside className="rounded-lg pb-4 flex flex-col gap-4 w-[94vw] sm:hidden">
          <Image
            src={service.image}
            alt={`Image showing ${service.title.toLowerCase()} work`}
            height={300}
            width={300}
            className="rounded-t-lg object-cover h-[14rem] xl:h-[14rem] w-full sm:w-[14rem] xl:w-[16rem]"
          />
          <div className="flex flex-col gap-1 border-b border-l border-r border-zinc-200 rounded-b-lg p-2 pb-8">
            <h3 className="text-xl sm:text-2xl font-medium">{service.title}</h3>
            <p className="text-xs opacity-50 w-full sm:max-w-[14rem] xl:max-w-[16rem]">{service.description.slice(0, 110)}</p>
          </div>
        </aside>
        <aside className="hidden border rounded-lg p-2 sm:p-4 sm:flex flex-col gap-4 w-[94vw] sm:w-full">
          <Image
            src={service.image}
            alt={`Image showing ${service.title.toLowerCase()} work`}
            height={300}
            width={300}
            className="rounded-lg object-cover h-[14rem] xl:h-[14rem] w-full sm:w-[14rem] xl:w-[16rem]"
          />
          <div className="flex flex-col gap-1">
            <h3 className="text-xl sm:text-2xl font-medium">{service.title}</h3>
          </div>
        </aside>
      </Link>
      {
        isEditor && (
          <div className="flex gap-2 justify-end">
            <Button
              variant={'ghost'}
              aria-label="delete"
              onClick={() => deleteHeroService(service._id)}
            ><Trash className="h-4 w-4 text-red-500" /></Button>
          </div>

        )
      }
    </div>
  );
};

export default ServiceCard;
